module.exports = __webpack_public_path__ + "static/img/logo-beco-svg.ab7c234.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-beco-svg.svg
// module id = g6EU
// module chunks = 0